import React from "react";
import "./speakerbio.css";
import img from '../../assets/user.png';

interface Speaker {
  name: string;
  speakerImageUrl?: string;
  company: string;
  designation: string;
  role: number;
  email: string;
}

interface SpeakerBioProps {
  speakerBio: Speaker[];
  defaultSpeakers: any[];
  isZoomSdkExpanded?: boolean
}

const SpeakerBio: React.FC<SpeakerBioProps> = ({ speakerBio, defaultSpeakers, isZoomSdkExpanded }) => {

  const defaultSpeakerEmails = defaultSpeakers.map((speaker: any) => speaker.email.toLowerCase());

  // Filter speakers based on role == 0 and exclude default speakers by email
  const filteredSpeakers = speakerBio.filter(
    speaker =>
      speaker.role === 0 &&
      !defaultSpeakerEmails.includes(speaker.email.toLowerCase()) &&
      !speaker.email.toLowerCase().includes("@arizent.com")
  );

  return (
    <div className="bio-wrapper" id='bio-speaker-view'>
      <div className="header" style={{textAlign: "center"}}>Speaker Bios</div>
      <hr />
      <div className="speakers-wrapper"
      style={{
        maxHeight:  isZoomSdkExpanded && window.innerWidth > 768 ? '300px' : '250px',
        minHeight: isZoomSdkExpanded && window.innerWidth > 768 ? '300px' : '250px',
      }}
      >
        {filteredSpeakers.map((speaker, index) => (
          <div className="speaker" key={index}>
            <div className="speakaer-logo">
              <img src={speaker.speakerImageUrl ? speaker.speakerImageUrl : img} alt={speaker.name} crossOrigin='anonymous'></img>
            </div>
            <div className="info">
              <div className="name">{speaker.name}</div>
              <div className="title">{speaker.designation}</div>
              <div className="company">{speaker.company}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SpeakerBio;
